import createReducer from 'utils/createReducer';
import { DEFAULT_SIDEBAR_TAB } from 'redux/modules/journeys/constants';

const SET_FETCHING = 'detail/SET_FETCHING';
const SET_DATA = 'detail/SET_DATA';
const SET_REVIEWING = 'detail/SET_REVIEWING';
const SET_DECISION_MODE = 'detail/SET_DECISION_MODE';
const SET_ACTION_LOADING = 'detail/SET_ACTION_LOADING';
const SET_SHIPPER_ORDER_ASSIGNMENT_ID = 'detail/SET_SHIPPER_ORDER_ASSIGNMENT_ID';
const SET_ERROR = 'detail/SET_ERROR';
const SET_MINERVA_INFO = 'detail/SET_MINERVA_INFO';
const SET_UNASSIGNING = 'detail/SET_UNASSIGNING';
const SET_ATOMIC_UPDATE = 'detail/SET_ATOMIC_UPDATE';
const SET_SUBMODAL = 'detail/SET_SUBMODAL';
const SET_SIDEBAR_TAB = 'detail/SET_SIDEBAR_TAB';
const SET_UPDATING_TIMES = 'detail/SET_UPDATING_TIMES';

// Initial State
const INIT_STATE = {
  data: null,
  fetching: true,
  opened: false,
  unassigning: false,
  actionDecision: {
    loading: false,
    mode: '',
    id: null,
  },
  shipperOrderAssignmentId: null,
  error: null,
  submodal: {
    name: '',
    params: {},
  },
  pdfLoading: false,
  sidebarTab: DEFAULT_SIDEBAR_TAB,
  updatingTimes: false,
};

// Reducers
export default createReducer(INIT_STATE, {
  [SET_FETCHING](state, payload) {
    return {
      ...state,
      fetching: payload,
    };
  },
  [SET_REVIEWING](state, payload) {
    return {
      ...state,
      reviewing: payload,
    };
  },
  [SET_DATA](state, payload) {
    return {
      ...state,
      data: payload,
    };
  },
  [SET_DECISION_MODE](state, payload) {
    return {
      ...state,
      actionDecision: {
        ...state.actionDecision,
        mode: payload.mode,
        id: payload.id,
      },
    };
  },
  [SET_ACTION_LOADING](state, payload) {
    return {
      ...state,
      actionDecision: {
        ...state.actionDecision,
        loading: payload,
      },
    };
  },
  [SET_SHIPPER_ORDER_ASSIGNMENT_ID](state, payload) {
    return {
      ...state,
      shipperOrderAssignmentId: payload,
    };
  },
  [SET_ERROR](state, payload) {
    return {
      ...state,
      error: payload,
    };
  },
  [SET_SUBMODAL](state, { name, params }) {
    return {
      ...state,
      submodal: {
        name,
        params,
      },
    };
  },
  [SET_MINERVA_INFO](state, { minervaInfo }) {
    return {
      ...state,
      minervaInfo,
    };
  },
  [SET_UNASSIGNING](state, { unassigning }) {
    return {
      ...state,
      unassigning,
    };
  },
  [SET_ATOMIC_UPDATE](state, payload) {
    return {
      ...state,
      data: {
        ...state.data,
        ...payload,
      },
    };
  },
  [SET_SIDEBAR_TAB](state, payload) {
    return {
      ...state,
      sidebarTab: payload,
    };
  },
  [SET_UPDATING_TIMES](state, payload) {
    return {
      ...state,
      updatingTimes: payload,
    };
  },
});

export const setReviewing = (reviewing) => ({
  type: SET_REVIEWING,
  payload: reviewing,
});

export const setFetching = (fetching) => ({
  type: SET_FETCHING,
  payload: fetching,
});

export const setUpdatingTimes = (updating) => ({
  type: SET_UPDATING_TIMES,
  payload: updating,
});

export const setData = (data) => ({
  type: SET_DATA,
  payload: data || INIT_STATE.data,
});

export const setDecisionMode = ({ id = null, mode }) => ({
  type: SET_DECISION_MODE,
  payload: {
    id,
    mode,
  },
});

export const setActionLoading = (loading) => ({
  type: SET_ACTION_LOADING,
  payload: loading,
});

export const setShipperOrderAssignmentId = (shipperOrderId) => ({
  type: SET_SHIPPER_ORDER_ASSIGNMENT_ID,
  payload: shipperOrderId,
});

export const setError = (error) => ({
  type: SET_ERROR,
  payload: error,
});

export const setSubmodal = (name, params = {}) => ({
  type: SET_SUBMODAL,
  payload: {
    name,
    params,
  },
});

export const setMinervaInfo = (minervaInfo) => ({
  type: SET_MINERVA_INFO,
  payload: {
    minervaInfo,
  },
});

export const setUnassigning = (unassigning) => ({
  type: SET_UNASSIGNING,
  payload: {
    unassigning,
  },
});

export const setAtomicUpdate = (parameterUpdated) => ({
  type: SET_ATOMIC_UPDATE,
  payload: parameterUpdated,
});

export const setSidebarTab = (tab) => ({
  type: SET_SIDEBAR_TAB,
  payload: tab,
});
